import { put, takeLatest } from 'redux-saga/effects';
import staffActionTypes from '../types';
import { fetchEditRequestsFailure, fetchEditRequestsSuccess } from '../actions';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';

export function* fetchEditRequests({ payload }) {
  try {
    const response = yield httpClient.get('/staff/profile-edit', { params: payload });
    yield put(fetchEditRequestsSuccess(response.data));
  } catch (error) {
    yield put(fetchEditRequestsFailure(error?.message));
    handleError(error);
  }
}

export function* onFetchEditRequests() {
  yield takeLatest(staffActionTypes.FETCH_EDIT_REQUESTS_START, fetchEditRequests);
}
